import api from "./api";

const AssetsImageAPI = {
    getAll: () => api.get(`/admin/assets-image/all`),
    update: (data) => api.post(`/admin/assets-image/update`, data),
    uploadFile: (data) => api.post(`/admin/assets-image/upload`, data),
    deleteMultiple: (data) => api.post(`/admin/assets-image/delete-multiple`, data),
    createFolder: (folderName) => api.post(`/admin/assets-image/create-folder`, folderName, { headers: { 'Content-Type': 'application/json' } }),
    syncAssets: () => api.post(`/admin/assets-image/sync`)
};

export default AssetsImageAPI;
